/**
 * Helpers compartidos para Fase 16 · Honorarios.
 */
import { PRODUCTOS, PRODUCTO_LABEL } from "../aceptacion/_common";

export { PRODUCTOS, PRODUCTO_LABEL };

export const BASE_CALCULO = [
    { value: "patrimonio", label: "% sobre patrimonio" },
    { value: "flujos", label: "% sobre flujos anuales" },
    { value: "sin_base", label: "Sin base (sólo fijo)" },
];

export const COT_ESTADOS = {
    borrador: { label: "Borrador", cls: "bg-slate-100 text-slate-700 border-slate-200" },
    pendiente_dg: { label: "Pendiente DG", cls: "bg-amber-50 text-amber-800 border-amber-200" },
    enviada: { label: "Enviada", cls: "bg-blue-50 text-blue-800 border-blue-200" },
    aprobada: { label: "Aprobada DG", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
    aceptada_cliente: { label: "Aceptada por cliente", cls: "bg-emerald-100 text-emerald-900 border-emerald-300" },
    rechazada: { label: "Rechazada", cls: "bg-red-50 text-red-700 border-red-200" },
    vencida: { label: "Vencida", cls: "bg-amber-50 text-amber-800 border-amber-200" },
};

/** Formatea MXN desde string decimal (Decimal del backend). */
export const fmtMXNDec = (s) => {
    if (s === null || s === undefined || s === "") return "—";
    const n = typeof s === "number" ? s : parseFloat(s);
    if (isNaN(n)) return "—";
    return new Intl.NumberFormat("es-MX", {
        style: "currency", currency: "MXN", maximumFractionDigits: 0,
    }).format(n);
};

export const fmtMXNDec2 = (s) => {
    const n = typeof s === "number" ? s : parseFloat(s);
    if (isNaN(n)) return "—";
    return new Intl.NumberFormat("es-MX", {
        style: "currency", currency: "MXN", maximumFractionDigits: 2,
    }).format(n);
};

export const fmtDateCot = (iso) => {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleDateString("es-MX", {
            day: "2-digit", month: "2-digit", year: "numeric",
        });
    } catch { return iso; }
};

export const diasVigencia = (vence_at) => {
    if (!vence_at) return null;
    const d = new Date(vence_at);
    return Math.ceil((d - new Date()) / (1000 * 60 * 60 * 24));
};

export const colorVigencia = (dias) => {
    if (dias === null) return "bg-slate-100 text-slate-700 border-slate-200";
    if (dias <= 5) return "bg-red-100 text-red-800 border-red-300";
    if (dias <= 15) return "bg-amber-100 text-amber-800 border-amber-300";
    return "bg-emerald-50 text-emerald-800 border-emerald-200";
};
